/* src/app/home/partials/invoices-to-be-authorised/invoices-to-be-authorised.component.scss */
/*# sourceMappingURL=invoices-to-be-authorised.component.css.map */
